require('./dist/floating-label/ds6/floating-label.css');
